exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img[data-v-d7e7c600]{margin-right:5px;cursor:pointer}@media (max-width:1130px){img[data-v-d7e7c600]{width:30px}}@media (max-width:775px){img[data-v-d7e7c600]{width:20px}.twitter[data-v-d7e7c600]{display:none}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d7e7c600","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/SocialIcons.vue
// module id = 186
// module chunks = 0